import "@chatui/core/es/styles/index.less";
import Chat, { Bubble, useMessages } from "@chatui/core";
import "@chatui/core/dist/index.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "./ModalForm";
import { Icon } from "@chatui/core";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ScrollDownButton from "./ScrollDown";
import ScrollUpButton from "./ScrollUp";
import "../src/App.css";
import FeedbackComponent from "./testFeedback";
import { v4 as uuidv4 } from "uuid";
import EditQuestionForm from "./EditQuestion";
import FeedbackModalForm from "./FeedbackModal";

const HtmlBubble = ({ html }) => {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

const initialMessages = [
  {
    type: "text",
    content: {
      text: "Welcome to MOSIP Knowledge Assistant! \n\nI'm here to help you navigate through a world of knowledge and assist you with any questions or information you may need.",
    },
    user: { avatar: "/assets/img/mosip.png" },
    copied: false,
  },
];

export default function App() {
  const { messages, appendMsg, setTyping } = useMessages(initialMessages);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [lastInteraction, setLastInteraction] = useState(null);
  const [feedbackState, setFeedbackState] = useState(null);
  const [isFeedbackAllowed, setIsFeedbackAllowed] = useState(true);
  const [copied, setCopied] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false); // New state to handle modal visibility
  const [feedbackComment, setFeedbackComment] = useState(""); // New state to store the user's comment
  const [savedQuestions, setSavedQuestions] = useState([]);
  const [chatInputValue, setChatInputValue] = useState("");
  const [isEditing, setIsEditing] = useState(false); // State to manage editing mode
  const [editMessageId, setEditMessageId] = useState(null); //stores question ID
  const [userQuestion, setUserQuestion] = useState({}); //storing user question
  const [questionId, setQuestionId] = useState(1); //generating unique question id
  const [feedbackStates, setFeedbackStates] = useState({}); //stores the response id for giving separate feedbacks
  const [currentIndex, setCurrentIndex] = useState(0); // Keep track of the current question

  //saving log whenver last Interaction is being udpdated
  useEffect(() => {
    lastInteraction && handleFeedbackClick();
  }, [lastInteraction]);

  useEffect(() => {
    // Retrieve recently asked questions from local storage
    const recentQuestions = JSON.parse(localStorage.getItem("recentQuestions"));

    if (Array.isArray(recentQuestions)) {
      const limitedQuestions = recentQuestions.slice(0, 3);
      // Update the saved questions state
      setSavedQuestions(limitedQuestions);
    }
  }, []);

  const submitFeedback = (feedbackType) => {
    const currentQuestion = userQuestion[currentIndex];
    // Handle submitting feedback with the currentQuestion
    // Increment the currentIndex to display the next question

    setCurrentIndex(currentIndex + 1);
    // console.log("Feedback Type submit",feedbackType)
    // This is the extracted logic for submitting feedback to the API
    if (isFeedbackAllowed) {
      const formData = JSON.parse(localStorage.getItem("formData")) || {};
      // console.log("Feedback state", feedbackState);
      if (feedbackType === "negative" || feedbackType === "positive")
        formData.feedback = feedbackType;
      // Generate a new epoch timestamp
      const timestamp = new Date();
      const formattedTimestamp = timestamp.toISOString();
      // Update formData with the new timestamp
      formData.timestamp = formattedTimestamp;
      formData.interaction = lastInteraction;
      setIsFeedbackAllowed(true);
      // Add the feedbackComment to formData if it exists
      if (feedbackComment.trim()) {
        formData.comment = feedbackComment;
      }

      axios
        .post("https://ai.mosip.sandbox.stataware.com/qa/feedback/newqna/_doc", formData)
        .then((response) => {
          console.log("Response Data:", response.data);
        })
        .catch((error) => {
          console.error("Error posting feedback:", error);
        });
    }
  };

  const defaultQuickReplies = [
    ...savedQuestions.slice(0, 3).map((question) => ({
      name: question,
      isHighlight: true,
    })),
  ];
  //genereate response id
  function generateUniqueId() {
    return uuidv4();
  }
  const responseId = generateUniqueId();

  function handleQuickReplyClick(userQuestion) {
    handleSend("text", userQuestion);
  }

  const handleFeedbackClick = (feedbackType = "none", responseId) => {
    // console.log(responseId);
    setFeedbackState(feedbackType);
    setFeedbackStates((prevFeedbackStates) => ({
      ...prevFeedbackStates,
      [responseId]: feedbackType,
    }));
    // Log the response from the API and its feedback state
    const response = messages.find((msg) => msg.responseId === responseId);
    if (response) {
      // console.log("API Response:", response.content.text);
      // console.log("Feedback State:", feedbackType);
    }
    setShowFeedbackModal(false);
    if (feedbackType === "negative") {
      // console.log("Negative modal", showFeedbackModal);
      console.log("Feedback Type", feedbackType);
      setFeedbackState(feedbackType);
      setFeedbackComment(""); // Clear any previous comment
      setShowFeedbackModal(true); // Always open the modal for negative feedback
      submitFeedback(feedbackType);
    } else {
      // For positive feedback, only set the feedback state
      setFeedbackState(feedbackType);
      setIsFeedbackAllowed(true);
      // console.log("Feedback state in handlefeedback:",feedbackType);
      // If positive, just submit without comment
      submitFeedback(feedbackType);
    }
  };

  const handleCloseModal = () => {
    // Check if the feedback is negative
    if (feedbackState === "negative") {
      // If the comment for negative feedback isn't provided
      if (!feedbackComment.trim()) {
        // alert("Please provide comments for your negative feedback.");
        return; // Exit the function without closing the modal or submitting feedback
      }
    }
    // Clear feedback state and comment
    // setFeedbackState(null);
    // // Set showFeedbackModal to false to close the modal
    // setShowFeedbackModal(false); // Change this line to set showFeedbackModal to false
    // console.log("Show feedback Modal", showFeedbackModal); // This will show 'false'
    submitFeedback();
  };
  //Sending questions
  function handleSend(type, val) {
    if (sendingMessage) return;

    if (type === "text" && val.trim()) {
      // Generate a unique ID for the question
      const id = questionId;
      setQuestionId((prevId) => prevId + 1);

      // Store the user's question and ID in userQuestions state
      setUserQuestion((prevUserQuestions) => ({
        ...prevUserQuestions,
        [id]: val,
      }));

      appendMsg({
        type: "text",
        content: { text: val },
        position: "right",
        user: { avatar: "/assets/img/user.png" },
        editable: true,
        id: id, // Set the ID property
      });
      // Save the user's question
      setSavedQuestions((prevQuestions) => {
        // Check if the question already exists
        if (!prevQuestions.includes(val) && val.trim() !== "") {
          const updatedQuestions = [val, ...prevQuestions];
          // Limit the array to 3 questions
          const limitedQuestions = updatedQuestions.slice(0, 3);
          localStorage.setItem(
            "recentQuestions",
            JSON.stringify(limitedQuestions)
          ); // Save to localStorage
          return updatedQuestions;
        }
        return prevQuestions; // If question exists, return the previous state
      });

      setTyping(true);
      setSendingMessage(true);

      axios
        .post("https://bot.mosip.net/api", {
          prompt: val,
          context: "",
        })
        .then((response) => {
          const responseData = response.data;
          const markdownContent = responseData.message; // this is markdown

          // Prepare the sources string only if sources exist
          let sources = "";
          if (responseData.sources && responseData.sources.length > 0) {
            // Added condition here
            sources = "\n\n<b>Sources:</b>\n";
            // Convert sources to a set to remove duplicates, then back to array
            let uniqueSources = Array.from(new Set(responseData.sources));
            uniqueSources.forEach((link) => {
              sources += `<a href="${link}">${link}</a>\n`;
            });
          }

          appendMsg({
            type: "text",
            content: {
              text: (
                <div>
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    children={markdownContent}
                  />
                  <div dangerouslySetInnerHTML={{ __html: sources }} />
                </div>
              ),
            }, // append sources to the message
            user: { avatar: "/assets/img/mosip.png" },
            feedback: true,
            responseId: responseId, // Set the ID property for the response
          });

          // updating the lastInteraction state with the assistant's response
          setLastInteraction({
            question: val,
            answer: responseData.message + sources,
          });

          setTyping(false);
          setSendingMessage(false);
        })
        .catch((error) => {
          console.error("Error sending message:", error);
        });
    }
  }

  //copy to clpboard method to handle copy for response
  function copyToClipboard(reactElement, responseId) {
    const textContent = reactElementToString(reactElement);
    // console.log("Response ID",responseId)
    navigator.clipboard
      .writeText(textContent)
      .then(() => {
        setCopied(responseId); // Indicate that text has been copied for this specific response
        setTimeout(() => setCopied(null), 2000); // Clear the 'copied' state after 2 seconds
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  }

  function reactElementToString(reactElement) {
    if (typeof reactElement === "string") {
      return reactElement;
    }
    if (Array.isArray(reactElement)) {
      return reactElement.map((child) => reactElementToString(child)).join("");
    }
    if (reactElement.props && reactElement.props.children) {
      return reactElementToString(reactElement.props.children);
    }
    return ""; // Default case (or you can handle other cases as needed)
  }
  //EDIT FUNCTION
  // Handle edit button click
  const handleEdit = (id) => {
    setIsEditing(true);
    setEditMessageId(id);
  };

  // Handle submission of the edited question
  const handleEditSubmit = (editedQuestion) => {
    setIsEditing(false);
    handleSend("text", editedQuestion); //sending edited question to the handle send
  };

  //render message content from api response
  function renderMessageContent(msg) {
    const { type, content, feedback, id, editable, responseId } = msg;
    //  console.log("Response DI:",responseId)
    if (editable) {
      return (
        <div className="chat-message">
          <div className="bubble-container">
            {/* Display the "Edit" button if message is editable */}
            <button
              onClick={() => handleEdit(id)}
              title="Edit"
              className="edit-button"
            >
              <img src="/assets/img/checkEdit.png" alt="Feedback" />
            </button>
            <Bubble content={content.text} />
          </div>
          {/* Render the EditQuestionForm below the user's question */}
          {isEditing &&
            editMessageId === id && ( //checking id of questions
              <EditQuestionForm
                initialQuestion={userQuestion[editMessageId]} //sending initial question as props to the editquestionform component
                onSave={(editedQuestion) => {
                  // Save the edited question and exit editing mode
                  setUserQuestion((prevUserQuestions) => ({
                    ...prevUserQuestions,
                    [id]: editedQuestion,
                  }));
                  setIsEditing(false);
                }}
                onCancel={() => {
                  setIsEditing(false);
                }}
                onSubmit={handleEditSubmit}
              />
            )}
        </div>
      );
    }

    if (feedback) {
      return (
        <div>
          <Bubble content={content.text} />
          <div className="feedback-icons">
            <Icon
              type="thumbs-up"
              onClick={() => handleFeedbackClick("positive", responseId)}
              className={
                feedbackStates[responseId] === "positive"
                  ? "positive-feedback"
                  : ""
              } // apply class based on state
            />
            <Icon
              type="thumbs-down"
              onClick={() => handleFeedbackClick("negative", responseId)}
              className={
                feedbackStates[responseId] === "negative"
                  ? "negative-feedback"
                  : ""
              } // apply class based on state
            />

            {/* Add copy to clipboard icon */}
            <Icon
              type="copy" // assuming 'copy' is the correct type for copy icon in @chatui/core (if not, use the appropriate one)
              onClick={() => copyToClipboard(content.text, responseId)}
              className="copy-feedback" // you can style this icon differently if needed
            />
            {/* Tooltip */}
            {copied === responseId && (
              <span style={{ marginLeft: "5px" }}>Copied!</span>
            )}
          </div>
        </div>
      );
    } else {
      switch (type) {
        case "text":
          return (
            <div className="chat-message">
              <div className="bubble-container">
                {/* Display the "Edit" button if message is editable */}
                {editable && (
                  <button
                    onClick={() => handleEdit(id)}
                    className="edit-button"
                  >
                    Edit
                  </button>
                )}
                <Bubble content={content.text} />
              </div>
            </div>
          );
      }
    }
  }

  return (
    <>
      <Modal />
      {showFeedbackModal && (
        <FeedbackModalForm
          feedbackType={feedbackState}
          handleClose={handleCloseModal}
          handleFeedbackSubmit={submitFeedback}
          feedbackComment={feedbackComment}
          setFeedbackComment={setFeedbackComment}
          onHide={handleCloseModal}
          question={userQuestion[currentIndex]}
          interaction={lastInteraction}
        />
      )}
      <div className="Top">
        <Chat
          navbar={{
            title: (
              <>
                <img
                  src="/assets/img/ey-logo.png"
                  alt="Logo"
                  style={{
                    float: "right",
                    height: "25px",
                    margin: "0 0 0 10px",
                  }}
                />{" "}
                MOSIP Knowledge Assistant Powered by Generative AI
              </>
            ),
            style: { backgroundColor: "blue" },
          }}
          locale={{
            send: "Send", // Your custom send button message
          }}
          quickReplies={defaultQuickReplies}
          onQuickReplyClick={(quickReply) =>
            handleQuickReplyClick(quickReply.name)
          }
          messages={messages}
          renderMessageContent={renderMessageContent}
          onSend={sendingMessage ? () => {} : handleSend} // If sendingMessage is true, don't call handleSend
          placeholder={sendingMessage ? "Please wait..." : "Type here"} // Show a different placeholder if we're waiting for a response
        />
        <div className="feedback-button-container">
          <FeedbackComponent />
        </div>
        <ScrollDownButton />
        <ScrollUpButton />
      </div>
    </>
  );
}
